import { render } from "./ReceptionModal.vue?vue&type=template&id=b1316818&scoped=true&ts=true&lang=pug"
import script from "./ReceptionModal.vue?vue&type=script&lang=ts"
export * from "./ReceptionModal.vue?vue&type=script&lang=ts"

import "./ReceptionModal.vue?vue&type=style&index=0&id=b1316818&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1316818"]])

export default __exports__